import { IconType } from "react-icons";
import { UserModuleNameTypes } from "./models/userAccess/UserAccess.model";
import { GiGoalKeeper } from "react-icons/gi";
import { GoGoal } from "react-icons/go";

type NavItemTypeWithoutChild = {
    label: string;
    moduleName: string;
    path: string;
    icon: IconType;
    children?: never;
};

type NavItemTypeWithChild = {
    label: string;
    moduleName: string;
    path?: never;
    icon: IconType;
    children?: {
        label: string;
        moduleName: string;
        path: string;
        icon: IconType;
    }[];
};

export type NavItemType = NavItemTypeWithChild | NavItemTypeWithoutChild;

export const GoalsNavigation: NavItemType[] = [
    {
        label: "Goal-Category",
        moduleName: UserModuleNameTypes.GOAL_CATEGORY,
        icon: GiGoalKeeper,
        path: "goal-categories",
      },
      {
        label: "Goal",
        moduleName: UserModuleNameTypes.GOAL,
        icon: GoGoal,
        path: "goal",
      },
    
];
